import React from 'react';
import { FramedTextType } from '@tcs/create-account/utils/prismic/types';
import RichTextWrapper from '@tcs/create-account/components/RichTextWrapper';
import { useStyles } from './style';

interface FramedTextProps {
  data: FramedTextType;
}

const FramedText: React.FC<FramedTextProps> = ({ data }) => {
  const classes = useStyles();
  const { title, text } = data;

  return (
    <section className={classes.wrapper}>
      <div className={classes.heading}>
        <h2 className={classes.title}>{title}</h2>
      </div>
      <div className={classes.textWrapper}>
        <RichTextWrapper text={text} />
      </div>
    </section>
  );
};

export default FramedText;
